<template>
  <div class="pa-5">
    <v-alert v-if="notFound" type="warning" prominent class="mb-4">
      {{ $t("errors.pef_not_found") }}
    </v-alert>
    <v-card>
      <v-row class="mx-auto pa-2">
        <v-col cols="12">
          <v-sheet>
            <v-row
              class="mx-auto pa-2"
              v-if="$store.state.user.item.role !== undefined"
              ><v-col class="ma-5" :cols="6" :sm="6" :lg="2">
                <v-row>
                  <b
                    >{{ $store.state.user.item.first_name | capitalize }}
                    {{ $store.state.user.item.last_name | capitalize }}</b
                  >
                </v-row>
                <v-row>
                  {{
                    $t(
                      "common.role." + $store.state.user.item.role.toLowerCase()
                    )
                  }}
                </v-row>
                <v-row>
                  <b class="pt-2">{{ $t("user.coachs_assigned") }}: </b>
                  <v-btn
                    v-if="
                      ['ADMIN', 'SUPERADMIN', 'MENTOR'].includes(
                        current_user.role
                      )
                    "
                    class="ml-3"
                    fab
                    width="30px"
                    height="30px"
                    color="blue"
                    @click="showPCR()"
                  >
                    <v-icon color="white" size="20">mdi-pencil</v-icon>
                  </v-btn>
                </v-row>
                <v-row>
                  <span v-html="displayPCR()"></span>
                </v-row>
              </v-col>
              <v-col cols="1"><v-divider vertical></v-divider> </v-col>
              <v-col class="ma-5" :cols="6" :sm="6" :lg="2">
                <v-row
                  ><b>{{ $t("user.year") }}</b
                  >: {{ $store.state.user.item.year }}</v-row
                >
                <v-row
                  ><b>{{ $t("user.squad") }}</b
                  >: {{ $store.state.user.item.squad.name | capitalize }}</v-row
                >
              </v-col>
              <v-col cols="1"><v-divider vertical></v-divider> </v-col>
              <v-col class="ma-5" :cols="6" :sm="6" :lg="1">
                <v-row justify="center">
                  <v-tooltip bottom v-if="can_edit_notification()">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        color="primary"
                        icon
                        @click="update_notification"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark v-if="notification_enable">
                          mdi-bell
                        </v-icon>
                        <v-icon dark v-else> mdi-bell-off </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      $t(
                        notification_enable
                          ? "user.disable_notification"
                          : "user.enable_notification"
                      )
                    }}</span>
                  </v-tooltip>
                </v-row>
              </v-col>
              <v-col class="ma-5" :cols="6" :sm="6" :lg="2">
                <v-row justify="center">
                  <v-dialog v-model="dialog" persistent max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        :loading="loading"
                      >
                        {{ $t("user.download_pdf") }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{
                          $t("user.download_pdf")
                        }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-col cols="12">
                            <p class="font-weight-bold">
                              {{ $t("user.filter_date") }}
                            </p>
                            <v-row>
                              <date-picker
                                v-model="from_date"
                                :label="$t('user.from_date')"
                              />
                            </v-row>
                            <v-row>
                              <date-picker
                                :max="now"
                                v-model="to_date"
                                :label="$t('user.to_date')"
                              />
                            </v-row>
                            <p class="font-weight-bold">
                              {{ $t("user.filter_categories") }}
                            </p>
                            <v-row>
                              <v-checkbox
                                v-model="selected"
                                :label="$tc('feedback.title', 2)"
                                value="feedbacks"
                              ></v-checkbox>
                            </v-row>
                            <v-row>
                              <v-checkbox
                                v-model="selected"
                                :label="$t('intervention.report.aggregate')"
                                value="interventions_aggregate"
                              ></v-checkbox>
                            </v-row>
                            <v-row>
                              <v-checkbox
                                v-model="selected"
                                :label="$t('intervention.report.details')"
                                value="detail_interventions"
                              ></v-checkbox>
                            </v-row>
                            <v-row>
                              <v-checkbox
                                v-model="selected"
                                :label="$tc('training.title', 2)"
                                value="trainings"
                              ></v-checkbox>
                            </v-row>
                            <v-row>
                              <v-checkbox
                                v-model="selected"
                                :label="$tc('ao.title', 2)"
                                value="aos"
                              ></v-checkbox>
                            </v-row>
                            <v-row>
                              <v-checkbox
                                v-model="selected"
                                :label="$tc('diaries.pef', 2)"
                                value="pef_diary"
                              ></v-checkbox>
                            </v-row>
                          </v-col>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="dialog = false"
                        >
                          {{ $t("common.close") }}
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="downloadPdf">
                          {{ $t("user.download_pdf") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row> </v-card
    ><br />
    <v-tabs v-if="!notFound" v-model="tab" align-with-title>
      <v-tab href="#followup">{{ $tc("user.followup", 1) }}</v-tab>
      <v-tab href="#diary">{{ $t("diaries.diary") }}</v-tab>
      <v-tab href="#skills">{{ $tc("skills.title", 1) }}</v-tab>
      <v-tab href="#training">{{ $tc("training.title", 1) }}</v-tab>
    </v-tabs>

    <v-tabs-items v-if="!notFound" :value="tab">
      <v-tab-item value="followup">
        <v-card flat class="ma-5">
          <v-row>
            <!-- mini statistic start -->
            <v-col cols="12" sm="12" lg="12">
              <FeedbacksTable :userId="$route.params.user_id.toString()" />
            </v-col>
            <v-col :cols="12" :sm="12" :lg="12">
              <InterventionsTable :userId="$route.params.user_id.toString()" />
            </v-col>
            <v-col :cols="12" :sm="12" :lg="12">
              <AosTable :userId="$route.params.user_id.toString()" />
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <v-tab-item value="diary">
        <v-card flat class="ma-5">
          <v-row>
            <!-- mini statistic start -->
            <v-col cols="12" sm="12" lg="12">
              <PefDiaryTable :userId="$route.params.user_id.toString()" />
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <v-tab-item value="skills">
        <v-card flat class="ma-5">
          <v-row>
            <!-- mini statistic start -->
            <v-col cols="12" sm="12" lg="12">
              <PEFSkillsTable />
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <v-tab-item value="training">
        <v-card flat class="ma-5">
          <v-row>
            <!-- mini statistic start -->
            <v-col :cols="12" :sm="12" :lg="12">
              <TrainingsTable :userId="$route.params.user_id.toString()" />
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="dialogShowPcr" width="unset">
      <PrcTable
        :pef="$store.state.user.item"
        @deleted="refresh"
        @add="refresh"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex"

import { FETCH_ONE, UPDATE } from "@/store/action-types"
import FeedbacksTable from "../../components/card/FeedbacksTable"
import InterventionsTable from "@/components/card/InterventionTable"
import AosTable from "@/components/card/AoTable"
import TrainingsTable from "@/components/card/TrainingTable"
import PefDiaryTable from "@/views/pef/PefDiaryTable"
import { saveAs } from "file-saver"
import { filenameFrom } from "@/utils/download"
import { API_URL } from "@/utils/config"
import Vue from "vue"
import JwtService from "@/utils/jwt.service"
import PEFSkillsTable from "@/components/card/PefSkillsTable"
import DatePicker from "@/components/form/DatePicker"
import PrcTable from "@/components/card/PcrTable.vue"

export default {
  name: "PefDetailsPage",
  components: {
    PrcTable,
    DatePicker,
    PEFSkillsTable,
    PefDiaryTable,
    TrainingsTable,
    AosTable,
    InterventionsTable,
    FeedbacksTable,
  },
  data: () => ({
    dialog: false,
    dialogShowPcr: false,
    loading: false,
    user_id: null,
    notFound: false,
    menu_to: false,
    menu: false,
    from_date: null,
    to_date: null,
    notification_enable: true,
    selected: [
      "feedbacks",
      "interventions",
      "trainings",
      "aos",
      "mentor_diary",
      "pef_diary",
      "interventions_aggregate",
    ],
  }),
  mounted() {
    this.user_id = this.$route.params.user_id
    this.refresh()
    let self = this
    if (this.can_edit_notification()) {
      this.FETCH_NOTIFICATION(this.$route.params.user_id).then(
        (_notif) => (self.notification_enable = _notif.enable)
      )
    }
  },
  computed: {
    now() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    },
    current_user() {
      return this.$store.state.user.profile
    },
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get() {
        return this.$route.query.tab
      },
    },
  },
  watch: {
    "$route.params.user_id"() {
      // call the method which loads your initial state
      console.log("REFRESH")
      this.refresh()
    },
  },
  methods: {
    showPCR() {
      this.dialogShowPcr = true
    },
    displayPCR() {
      return this.$store.state.user.item.pef_relation
        .map((item) => {
          let style = ""
          const endPeriod = new Date(item.end_period)
          const now = new Date()
          if (!item.is_active) {
            if (endPeriod > now) {
              style = "color: grey;"
            } else {
              return ""
            }
          }
          return (
            "<div style='" +
            style +
            "'>" +
            item.coach.first_name +
            " " +
            item.coach.last_name +
            "</div>"
          )
        })
        .join("")
    },
    can_edit_notification() {
      return ["MENTOR"].includes(this.current_user.role)
    },
    update_notification() {
      let self = this

      this.UPDATE({
        id: this.$route.params.user_id,
        enable: !this.notification_enable,
      }).then((_notif) => (self.notification_enable = _notif.enable))
    },
    async downloadPdf() {
      this.dialog = false
      this.loading = true
      Vue.axios({
        url: API_URL + "users/" + this.$route.params.user_id + "/pdf",
        responseType: "blob",
        method: "GET",
        params: {
          display: this.selected,
          ...(this.from_date && {
            from_date: this.from_date,
          }),
          ...(this.to_date && {
            to_date: this.to_date,
          }),
        },
        headers: {
          Authorization: "Bearer " + JwtService.getToken(),
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      })
        .then((response) => {
          saveAs(response.data, filenameFrom(response, "rapport.pdf"))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async refresh() {
      this.loading = true
      this.notFound = false
      try {
        await this.FETCH_ONE(this.$route.params.user_id)
      } catch (err) {
        this.notFound = true
      }
      this.loading = false
    },
    ...mapActions("user", [FETCH_ONE]),
    ...mapActions("notification", {
      FETCH_NOTIFICATION: FETCH_ONE,
      UPDATE: UPDATE,
    }),
  },
}
</script>
